import { Button, Stack, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { ChangeEvent } from "react";
import DownloadIcon from '@mui/icons-material/Download';


interface Props {
    label: string,
    extension: string,
    uploadFn: (e: ChangeEvent<HTMLInputElement>) => void,
    uploadAllFn: (e: ChangeEvent<HTMLInputElement>) => void,
    downloadFn: () => void
}


const ImportComponent = ({ label, extension, uploadFn, downloadFn }: Props) => {
    return (
        <Stack direction="row" sx={{ "marginBottom": ".5em" }} spacing={2}>
            <Typography>{label}</Typography>
            <Button variant="contained" endIcon={<DownloadIcon />} onClick={downloadFn}>
                Télécharger
            </Button>

            <Button
                component="label"
                variant="outlined"
                startIcon={<UploadFileIcon />}>
                Téléverser
                <input type="file" accept={extension} hidden onChange={uploadFn} />
            </Button>

        </Stack>
    );
};


export default ImportComponent;